// Guide size check (4.10.55, user OK 2026-10-27). A whole guide is saved as
// one JSON string in a single guide_data document, and Firestore refuses any
// document over 1 MiB. Before this check a guide past the limit just failed
// to save with a generic error. Now a save near the limit gets a warning, and
// one too close to it is refused before anything is written, with a message
// saying what to do. Same file in mobile.

export const GUIDE_DOC_LIMIT = 1048576; // Firestore's maximum document size, bytes
export const WARN_AT = 0.85; // warn from 85% of the limit
export const BLOCK_AT = 0.98; // refuse from 98% (the doc also holds ids and field names)

// UTF-8 length without TextEncoder (not on every React Native engine).
const utf8Bytes = (s) => {
  let n = 0;
  for (let i = 0; i < s.length; i++) {
    const c = s.charCodeAt(i);
    if (c < 0x80) n += 1;
    else if (c < 0x800) n += 2;
    else if (c >= 0xd800 && c <= 0xdbff && i + 1 < s.length) { n += 4; i++; } // surrogate pair
    else n += 3;
  }
  return n;
};

// dataString: the JSON string about to be stored in guide_data.data.
// Returns { bytes, percent, level: "ok" | "warn" | "block", message }.
export function checkGuideSize(dataString) {
  const bytes = utf8Bytes(String(dataString || ""));
  const percent = Math.round((bytes / GUIDE_DOC_LIMIT) * 100);
  const kb = Math.round(bytes / 1024);
  if (bytes >= GUIDE_DOC_LIMIT * BLOCK_AT)
    return {
      bytes,
      percent,
      level: "block",
      message:
        `This guide is too large to save (${kb} KB; the limit is 1,024 KB). Nothing was saved. ` +
        "Make it smaller and save again: shorten long notes or the itinerary, remove pictures pasted into notes (link them instead), or move some days into a second guide.",
    };
  if (bytes >= GUIDE_DOC_LIMIT * WARN_AT)
    return {
      bytes,
      percent,
      level: "warn",
      message: `This guide is ${percent}% of the largest size a guide can be saved at (${kb} KB of 1,024 KB). Consider shortening long notes or splitting it into two guides.`,
    };
  return { bytes, percent, level: "ok", message: "" };
}
